// extracted by mini-css-extract-plugin
export default {"base":"WeakConnectorBanner_base__IOIJD","purple":"WeakConnectorBanner_purple__gQYKJ","text":"WeakConnectorBanner_text__LpJ7v","close":"WeakConnectorBanner_close__BoWtc"};